import React, { useRef, useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './TruncateText.module.css';

const TruncateText = React.forwardRef(function TruncateText(
  { children, lines = 2, className, style, ...rest },
  ref
) {
  const innerRef = useRef(null);
  const [truncated, setTruncated] = useState(false);

  const setRefs = node => {
    innerRef.current = node;
    if (typeof ref === 'function') ref(node);
    else if (ref) ref.current = node;
  };

  useLayoutEffect(() => {
    const el = innerRef.current;
    if (!el) return undefined;
    const check = () => setTruncated(el.scrollHeight > el.clientHeight + 1);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [children, lines]);

  return (
    <span
      ref={setRefs}
      className={cn(styles.clamp, className)}
      title={truncated && typeof children === 'string' ? children : undefined}
      style={{ WebkitLineClamp: lines, ...style }}
      {...rest}>
      {children}
    </span>
  );
});

TruncateText.propTypes = {
  children: PropTypes.node,
  lines: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
};

export default TruncateText;
